import * as actionTypes from './../actions/feedingGuidelinesLineChartAction';

const initialState = {
  data: {},
  pending: true,
  error: null,
  ready: false,
  chartData: null,
  chartOptions: null,
};

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.FETCH_DATA_PENDING:
      
      return {
        ...state,
        pending: true
      };
    case actionTypes.FETCH_DATA_SUCCESS:
      return {
        ...state,
        pending: false,
        ready: true,
        data: action.data,
      };
    case actionTypes.FETCH_DATA_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    case actionTypes.SET_CHART_DATA:
      return {
        ...state,
        chartData: action.chartData,
        chartOptions: action.chartOptions,
      };
    default:
      return state;
  }
};

export default reducer;
